import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { EMAIL } from '../store/actionTypes';
import { Email, EmailInput } from './models/email';

export const email = createApi({
  reducerPath: EMAIL,
  baseQuery,
  tagTypes: ['Email'],
  endpoints: builder => ({
    sendEmail: builder.mutation<Email, EmailInput>({
      query: variables => ({
        document: gql`
          mutation SendEmail($email: EmailInput!) {
            sendEmail(email: $email) {
              status {
                code
              }
            }
          }
        `,
        variables: { email: variables },
      }),
      transformResponse: (response: any) => response?.sendEmail,
    }),
  }),
});

export const { useSendEmailMutation } = email;
